module.exports = __webpack_public_path__ + "static/media/UserLogo.90038243.svg";